import { render } from "./Pattern.vue?vue&type=template&id=3bdd7936"
import script from "./Pattern.vue?vue&type=script&lang=js"
export * from "./Pattern.vue?vue&type=script&lang=js"
script.render = render

export default script